import React from 'react';
import TranslationText from '../../../components/Translation/TranslationText';
import { Trans } from 'react-i18next';
import { SmartIdTextLogo } from "../../../icons/SmartIdTextLogo.jsx";

export function SmartIdVerificationStep(props) {
  const {
    pin,
    isWaiting,
    onCancel,
    titleTextKey,
  } = props;

  return (    
    <>
      <div className="smart-id-prompt-card">
        <div className="smart-id-logo-container">
          <SmartIdTextLogo width="40%" />
        </div>
        
        <div className="page-description-row">
          <p>
            <TranslationText text={titleTextKey} />
          </p>
        </div>

        <h1><b>{pin}</b></h1>

        <div className="page-description-row">
          <p>
            <Trans i18nKey='smart_id_verification_prompt_view_confirm_code_message' components={{ bold: <b /> }}/>
          </p>
        </div>
          
        {isWaiting && (                 
          <div className="smart-id-waiting">
            <div className="spinner-container">
              <div className="spinner"></div>
            </div>
            <p className="waiting-text">
              <TranslationText text="smart_id_verification_prompt_view_waiting_message" />
            </p>
          </div>
        )}
      </div>
      
      {onCancel && (
        <div className="button-row">
          <button
            type="button" 
            className="button -secondary full-width"
            onClick={onCancel}
          >
            <TranslationText text="cancel_button" />
          </button>
        </div>
      )}
    </>
  );
} 